module.exports = __webpack_public_path__ + "static/media/borre-coach.392136ce.png";